module.exports = __webpack_public_path__ + "assets/img/27_1575_big.ed8649ab.jpg";